import { useEffect, useState } from "react";
import { useStore } from "@/context/StoreContext";
import { Clock } from "lucide-react";

const calc = (end) => {
  const diff = new Date(end).getTime() - Date.now();
  if (diff <= 0) return null;
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  return { d, h, m, s };
};

export const PromoBar = () => {
  const { settings } = useStore();
  const [t, setT] = useState(null);

  useEffect(() => {
    if (!settings?.promo_end) return;
    const tick = () => setT(calc(settings.promo_end));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [settings]);

  if (!settings?.promo_active || !t) return null;
  const pad = (n) => String(n).padStart(2, "0");

  return (
    <div className="bg-[#0a0a0a] text-white" data-testid="promo-bar">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-4 gap-y-1 px-4 py-2.5 text-center text-xs">
        <span className="inline-flex items-center gap-1.5 uppercase tracking-[0.15em] text-white/70"><Clock className="h-3.5 w-3.5" /> {settings.promo_text}</span>
        <span className="font-display tabular-nums tracking-wider" data-testid="promo-countdown">
          {t.d}d {pad(t.h)}:{pad(t.m)}:{pad(t.s)}
        </span>
      </div>
    </div>
  );
};
